// src/components/demo/DemoHomepage.js
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import '../home/Homepage.css';
import './DemoHomepage.css';
import DemoFitnessPage from './DemoFitnessPage';
import DemoLekhiPage from './DemoLekhiPage';

const MOTIVATION = {
  mr: 'वर्दी मिळत नाही, ती कमवावी लागते!',
  en: 'A uniform isnt given. It is earned!'
};

const WEEK = [
  { label: 'M', status: 'completed' },
  { label: 'T', status: 'completed' },
  { label: 'W', status: 'completed' },
  { label: 'T', status: 'today' },
  { label: 'F', status: 'future' },
  { label: 'S', status: 'future' },
  { label: 'S', status: 'future' }
];

const DemoHomepage = () => {
  const { logout } = useAuth();
  const [language, setLanguage] = useState(() =>
    localStorage.getItem('spocademy_language') || 'mr'
  );
  const [currentView, setCurrentView] = useState('homepage');
  const scrollRef = useRef(null);

  const t = language === 'mr'
    ? {
        points: 'गुण', vyayam: 'व्यायाम', lekhi: 'लेखी', day: 'Day',
        todayTraining: 'आजचे प्रशिक्षण', tomorrow: 'उद्या', dayAfter: 'परवा',
        villageRankings: 'गावांची क्रमवारी', pts: 'गुण', logout: 'लॉग आउट'
      }
    : {
        points: 'Points', vyayam: 'Workout', lekhi: 'Lekhi', day: 'Day',
        todayTraining: "Today's Training", tomorrow: 'Tomorrow', dayAfter: 'Day After',
        villageRankings: 'Village Rankings', pts: 'pts', logout: 'Log Out'
      };

  useEffect(() => {
    if (currentView !== 'homepage') return;
    setTimeout(() => {
      if (scrollRef.current) {
        const currentCard = scrollRef.current.querySelector('.day-card.current');
        if (currentCard) {
          currentCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }, 400);
  }, [currentView]);

  const handleLanguageToggle = () => {
    const newLang = language === 'en' ? 'mr' : 'en';
    setLanguage(newLang);
    localStorage.setItem('spocademy_language', newLang);
  };

  const handleLogout = async () => {
    await logout();
  };

  const renderPastCard = (dateLabel, key) => (
    <div key={key} className="day-card completed past-card">
      <div className="past-card-date">{dateLabel}</div>
      <div className="past-card-status-list">
        <div className="past-card-row">
          <span className="past-card-icon done">✓</span>
          <span className="past-card-label">{t.vyayam}</span>
        </div>
        <div className="past-card-row">
          <span className="past-card-icon done">✓</span>
          <span className="past-card-label">{t.lekhi}</span>
        </div>
      </div>
    </div>
  );

  const renderFutureCard = (label, key) => (
    <div key={key} className="day-card locked future-card">
      <div className="future-card-date">{label}</div>
      <div className="future-card-status-list">
        <div className="future-card-row">
          <span className="future-card-icon">🔒</span>
          <span className="future-card-label">{t.vyayam}</span>
        </div>
        <div className="future-card-row">
          <span className="future-card-icon">🔒</span>
          <span className="future-card-label">{t.lekhi}</span>
        </div>
      </div>
    </div>
  );

  if (currentView === 'demofitness') {
    return <DemoFitnessPage onBack={() => setCurrentView('homepage')} />;
  }

  if (currentView === 'demolekhi') {
    return <DemoLekhiPage onBack={() => setCurrentView('homepage')} />;
  }

  return (
    <div className="homepage-container">
      <div className="homepage-header">
        <div className="header-left">
          <div className="header-greeting">Hi, Virat Kohli</div>
          <div className="header-village">Pune</div>
        </div>
        <div className="header-center">
          <div className="points-circle">45</div>
          <div className="points-label">{t.points}</div>
        </div>
        <button className="lang-toggle" onClick={handleLanguageToggle}>
          {language === 'en' ? 'मराठी' : 'EN'}
        </button>
      </div>

      <div className="homepage-content">

        <div className="motivational-message">
          {MOTIVATION[language]}
        </div>

        <div className="streak-section">
          <div className="streak-left">
            <span className="streak-number">29</span>
            <span className="streak-fire">🔥</span>
          </div>
          <div className="streak-divider" />
          <div className="streak-days">
            {WEEK.map((d, i) => {
              const iconClass = d.status === 'completed' ? 'completed' : d.status === 'today' ? 'missed' : 'future';
              return (
                <div key={i} className="streak-day">
                  <span className={`streak-day-icon ${iconClass}`}>🔥</span>
                  <span className="streak-day-label">{d.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="training-path">
          <div className="path-container" ref={scrollRef}>
            {renderPastCard('मंगळ', 'past1')}
            {renderPastCard('बुध', 'past2')}

            <div className="day-card current">
              <div className="current-card-header">{t.todayTraining}</div>
              <button className="action-button" onClick={() => setCurrentView('demofitness')}>
                <span className="action-button-label">{t.vyayam}</span>
                <span className="action-button-day">{t.day} 30</span>
              </button>
              <button className="lekhi-button" onClick={() => setCurrentView('demolekhi')}>
                <span className="action-button-label">{t.lekhi}</span>
                <span className="action-button-day">{t.day} 15</span>
              </button>
            </div>

            {renderFutureCard(t.tomorrow, 'tomorrow')}
            {renderFutureCard(t.dayAfter, 'dayafter')}
          </div>
        </div>

        <div className="leaderboard-section">
          <div className="leaderboard-title">{t.villageRankings}</div>
          <div className="leaderboard-list">
            <div className="leaderboard-row user-village">
              <span className="leaderboard-rank gold">1</span>
              <span className="leaderboard-name">Pune</span>
              <span className="leaderboard-points">183 {t.pts}</span>
            </div>
          </div>
        </div>

        <button className="demo-logout-button" onClick={handleLogout}>
          {t.logout}
        </button>

      </div>
    </div>
  );
};

export default DemoHomepage;